import { animate } from 'animejs';
import { refs, domReady, booleanDataset, hasBooleanDataset } from '../modules/utils.js';

class FaqList extends HTMLElement {
  static get observedAttributes() {
    return ['data-index', 'data-category'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-index') {
      const prevIndex = parseInt(oldValue, 10);
      const index = parseInt(newValue, 10);
      this.refs.items?.forEach((el, i) => booleanDataset(el, 'active', i === index));
      this.#toggleItem(prevIndex);
      this.#toggleItem(index);
    }
    if (name === 'data-category') {
      this.refs.categories?.forEach((el) => booleanDataset(el, 'active', el.dataset.value === newValue));
    }
  }

  async connectedCallback() {
    await domReady();
    this.refs = refs(this);
    this.#listeners();
  }

  #listeners() {
    this.refs.items?.forEach((el, i) => {
      el.addEventListener('click', () => {
        const index = parseInt(this.dataset.index, 10);
        this.dataset.index = index === i ? -1 : i;
      });
    });

    this.refs.categories?.forEach((el) => {
      el.addEventListener('click', () => {
        // scroll to the top of the list
        const handle = el.dataset.value;
        this.refs.titles?.forEach((title) => {
          if (title.dataset.value === handle) {
            const top = title.getBoundingClientRect().top + window.scrollY;
            const offset = Math.max(0, top - 10 * (window.innerHeight / 100));
            window.scrollTo({
              top: offset,
              behavior: 'smooth'
            });
          }
        });
      });
    });

    const titlesIntersecting = [];
    const observer = new IntersectionObserver(
      (entries) => {
        entries.filter(entry => !entry.isIntersecting).forEach((entry) => {
          if (titlesIntersecting.includes(entry.target)) {
            titlesIntersecting.splice(titlesIntersecting.indexOf(entry.target), 1);
          }
        });
        entries.filter(entry => entry.isIntersecting).forEach((entry) => {
          if (!titlesIntersecting.includes(entry.target)) {
            titlesIntersecting.push(entry.target);
          }
        });
        if (titlesIntersecting.length) {
          let topMost = titlesIntersecting[0];
          titlesIntersecting.forEach((title) => {
            if (title.getBoundingClientRect().top < topMost.getBoundingClientRect().top) {
              topMost = title;
            }
          });
          if (topMost) {
            this.dataset.category = topMost.dataset.value;
          }
        }
      }
    );

    this.refs.titles?.forEach((title) => observer.observe(title));
  }

  #toggleItem(index) {
    if (isNaN(index) || index < 0) return;
    const el = this.refs.items[index];
    const isActive = hasBooleanDataset(el, 'active');
    const contentEl = el.querySelector('[data-content]');
    if (!contentEl) return;

    let height = 0;
    if (isActive) {
      contentEl.style.height = 'auto';
      height = contentEl.offsetHeight;
      contentEl.style.height = null;
    }

    animate(
      contentEl,
      {
        height,
        duration: 300,
        ease: 'outQuad',
      }
    );
  }
}

customElements.define('faq-list', FaqList);
